import { useMutation } from 'urql';
import { useI18n } from '@packages/shared/src/hooks/useI18n';
import { SendRsvMessageDocument } from '@packages/gql/generated/shopping/SendRsvMessageDocument';
import { formatDate } from '../../../../utils';
import type { FormValues } from '../RateProtectionForm';

/* GraphQl */ `
mutation SendRsvMessage($messageRequest: MessageRequestInput) {
  sendRsvMessage(messageRequest: $messageRequest) {
    ... on ErrorResponse {
      errors
    }
    ... on MessageResponse {
      success
    }
  }
}`;

export const useSendRsvMessageGqlMutation = () => {
  const [, executeMutation] = useMutation(SendRsvMessageDocument);
  const { language } = useI18n();
  return ({ formData }: { formData: FormValues }) => {
    const {
      birthday,
      city,
      customerid: customerId,
      email: emailAddress,
      firstname,
      housenumber: houseNumber,
      lastname,
      message = '',
      salutation,
      street,
      postalCode: zipCode,
    } = formData;
    return executeMutation({
      messageRequest: {
        birthday: birthday && formatDate(birthday),
        city,
        customerId,
        emailAddress,
        firstname,
        houseNumber,
        lastname,
        locale: language,
        message,
        salutation,
        street,
        subject: '',
        zipCode,
      },
    });
  };
};
